import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Icon from '../../../icon';
import { DIRECTIONS } from './constants';

const TabsScrollButton = ({ direction, onClick, noBackground = false }) => {
  const iconGlyph = direction === DIRECTIONS.left ? 'small-left-arrow' : 'small-right-arrow';
  const classes = classNames('ws-ui-tabs-scroll-button', {
    'ws-ui-tabs-scroll-button--no-background': noBackground,
  });

  return (
    <button className={classes} onClick={onClick}>
      <span className="ws-ui-tabs-scroll-button__icon">
        <Icon glyph={iconGlyph} type="inherit" size="100%" />
      </span>
    </button>
  );
};

TabsScrollButton.propTypes = {
  direction: PropTypes.oneOf(Object.values(DIRECTIONS)).isRequired,
  onClick: PropTypes.func.isRequired,
  noBackground: PropTypes.bool,
};

export default TabsScrollButton;
